const NIB = [{
  link: '/health-information/member-services/direct-debit-service-agreement',
  text: 'Direct Debit Request Service Agreement',
  iconType: 'URL'
}];
const WHITELABEL = [{
  link: 'https://www.nib.com.au/health-information/member-services/direct-debit-service-agreement',
  text: 'Direct Debit Request Service Agreement',
  iconType: 'URL'
}];
const IMAN = [{
  link: '/docs/iman-direct-debit-request',
  text: 'Direct Debit Request Service Agreement',
  iconType: 'PDF'
}];
// non-whitelabel solution
const GU = [{
  link: '/docs/direct-debit-service-agreement',
  text: 'Direct Debit Request Service Agreement',
  iconType: 'URL'
}];
// ARHI whitelabel solution
const GUHEALTH = [{
  link: 'https://www.guhealth.com.au/docs/direct-debit-service-agreement-nab656655',
  text: 'Direct Debit Request Service Agreement',
  iconType: 'URL'
}];
const DIRECT_DEBIT_RULES_LINKS = {
  ARHI: NIB,
  APIA: WHITELABEL,
  ING: WHITELABEL,
  IWHI: NIB,
  IMAN,
  AAMI: WHITELABEL,
  SUNCORP: WHITELABEL,
  PRICELINE: WHITELABEL,
  GU,
  SENIORS: WHITELABEL,
  REAL: WHITELABEL,
  NIBP2PWEB: WHITELABEL,
  CORPORATE: WHITELABEL,
  GUHEALTH: GUHEALTH
};
export default DIRECT_DEBIT_RULES_LINKS;